import './wp-telegram-form.scss';

//With this import I guess we declare that this is a Vue component (?)
import Vue from 'vue';

// This allows to do mixins and... standard Vue component interface?
import Component, { mixins } from 'vue-class-component';

import WpBaseComponent from './../wp-base-component';
import { ITelegramService, ITelegramProvider, TelegramSymbols, BaseSystemLocalizationDictionary, INotificationService, NotificationSymbols } from 'web-platform-help-desk-core-frontend-ui';

export const wpTelegramFormProps = Vue.extend({
    props: {
        value: {
            required: false,
            default: false
        }
    }
});

@Component({
    template: require("./wp-telegram-form.html"),
})

export default class WpTelegramForm extends mixins(WpBaseComponent, wpTelegramFormProps, Vue) {
    protected _service!: ITelegramService;
    protected _provider!: ITelegramProvider;
    protected _notificationService!: INotificationService;
    
    TextMessage: string = ''; // Text message
    FormImage: any = null;  // Image
    PhoneNumber: string = '+7'; // Default value, should be changed or empty
    TelegramLink: string = '';
    FormValid: boolean = false; // Is form valid or not ?
    Loading: boolean = true;
    TextHeader: string = "Telegram бот помощник";

    FormTextRules: any = [
        (value: string) => value.length < 65 || 'Максимальный размер сообщения - 64 символа',
    ];

    FormImageRules: any = [
        (value: File) => !value || value.size < 10000000 || 'Максимальный размер файла - 10 мегабайт',
    ];

    FormPhoneRules: any = [
        (value: string) => value.length === 16 || 'Телефон должен быть длинной в 10 цифр', // Without + 7 ( ) - -
    ];

    // This will prevent the phone field from having no value, defaulting it to "+7"
    // This needs a better fix. this.PhoneNumber doesn't change without async and await keywords
    formPhoneCheck() {
        if (this.PhoneNumber.length < 3) this.PhoneNumber = "+7";
    };

    mounted() {
        // Called after the instance has been mounted
        this.$nextTick(function () {
            // Use this scope if you want to WAIT for entire view to be mounted
            // Register the service
            this._service = this.GlobalService.Get<ITelegramService>(TelegramSymbols.TelegramService);
            this._notificationService = this.GlobalService.Get<INotificationService>(NotificationSymbols.NotificationService);
            this.Loading = false;
        });
    };

    async processData(e: Event): Promise<void> {
        this.Loading = true;
        try {
            // Try to validate the form
            (this.$refs.form as Vue & { validate: () => boolean }).validate();

            if (this.FormValid) {
                let requestResult = await this._service.ProcessNumber(this.PhoneNumber, this.TextMessage);
                if (requestResult.Success) {
                    this.TelegramLink = requestResult.Data!.toString();
                    this._notificationService.Success("Ссылка успешно сгенерирована", "Ссылка успешно создана!");
                } else {
                    this._notificationService.Error("Ошибка", requestResult.Data!.toString());
                };
            };

        } catch (e) {
            // Couldn't validate the form
        } finally {
            this.Loading = false;
        };
    };
};

export class WpTelegramFormDictionary extends BaseSystemLocalizationDictionary {
    TextHeader: string = 'Telegram link generator';
    InputPlaceholder: string = 'Phone number';
    UIBtnSend: string = 'Get a link';
};